module.exports = __webpack_public_path__ + "static/media/animation5.31a8168a.jpg";